var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "monthly-welfare-page" },
    [
      _c(
        "el-card",
        { staticClass: "search-card", attrs: { shadow: "never" } },
        [
          _c(
            "el-form",
            { attrs: { inline: true, model: _vm.searchForm, size: "small" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "名称" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { placeholder: "标题搜索", clearable: "" },
                    model: {
                      value: _vm.searchForm.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "title", $$v)
                      },
                      expression: "searchForm.title",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "启用" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "120px" },
                      attrs: { placeholder: "全部", clearable: "" },
                      model: {
                        value: _vm.searchForm.isEnable,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "isEnable", $$v)
                        },
                        expression: "searchForm.isEnable",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "启用", value: 1 } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "禁用", value: 0 } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.handleFilter },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-refresh" },
                      on: { click: _vm.resetSearch },
                    },
                    [_vm._v("重置")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-plus" },
                      on: { click: _vm.handleAdd },
                    },
                    [_vm._v("添加每月福利")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticStyle: { "margin-top": "10px" }, attrs: { shadow: "never" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "", stripe: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "id",
                  label: "编号",
                  width: "80",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "title",
                  label: "标题",
                  "min-width": "160",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "会员级别",
                  width: "180",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.levelsText(row.userLevels)) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "领取数据", width: "100", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openJoin(row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                row.receiveCount != null ? row.receiveCount : 0
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "启用", width: "80", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.isEnable === 1
                          ? _c("i", {
                              staticClass: "el-icon-success",
                              staticStyle: {
                                color: "#67C23A",
                                "font-size": "18px",
                              },
                            })
                          : _c("i", {
                              staticClass: "el-icon-error",
                              staticStyle: {
                                color: "#F56C6C",
                                "font-size": "18px",
                              },
                            }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sort",
                  label: "排序",
                  width: "80",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "更新时间", width: "170", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formatJoinTime(
                                row.lastModifiedDate || row.createDate
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "260",
                  align: "center",
                  "class-name": "col-ops",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          { staticClass: "op-btns" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEdit(row)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "warning", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleToggle(row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      row.isEnable === 1 ? "禁用" : "启用"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "danger", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDelete(row)
                                  },
                                },
                              },
                              [_vm._v("移除")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.searchForm.page,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.searchForm.limit,
                  total: _vm.total,
                },
                on: {
                  "current-change": function (p) {
                    _vm.searchForm.page = p
                    _vm.loadList()
                  },
                  "size-change": function (s) {
                    _vm.searchForm.limit = s
                    _vm.searchForm.page = 1
                    _vm.loadList()
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.editForm.id ? "编辑每月福利" : "添加每月福利",
            visible: _vm.editVisible,
            width: "960px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.editVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "editForm",
              attrs: {
                model: _vm.editForm,
                rules: _vm.rules,
                "label-width": "110px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "标题", prop: "title" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "360px" },
                    attrs: { placeholder: "例: LV1每月福利" },
                    model: {
                      value: _vm.editForm.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "title", $$v)
                      },
                      expression: "editForm.title",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "会员级别", prop: "userLevels" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.levelChecks,
                        callback: function ($$v) {
                          _vm.levelChecks = $$v
                        },
                        expression: "levelChecks",
                      },
                    },
                    [
                      _c("el-checkbox", { attrs: { label: "10" } }, [
                        _vm._v("普卡"),
                      ]),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "20" } }, [
                        _vm._v("银卡"),
                      ]),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "30" } }, [
                        _vm._v("金卡"),
                      ]),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "40" } }, [
                        _vm._v("黑金卡"),
                      ]),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "50" } }, [
                        _vm._v("钻石卡"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "奖励券包", required: "" } },
                [
                  _vm._l(_vm.editForm.items, function (row, idx) {
                    return _c("div", { key: idx, staticClass: "pkg-block" }, [
                      _c(
                        "div",
                        { staticClass: "pkg-row" },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "pkg-select",
                              attrs: {
                                filterable: "",
                                placeholder: _vm.pkgSelectTip,
                                "no-data-text": _vm.pkgSelectTip,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.onPackageChange(row)
                                },
                              },
                              model: {
                                value: row.packageId,
                                callback: function ($$v) {
                                  _vm.$set(row, "packageId", $$v)
                                },
                                expression: "row.packageId",
                              },
                            },
                            _vm._l(_vm.freePackages, function (p) {
                              return _c("el-option", {
                                key: p.id,
                                attrs: {
                                  label:
                                    (p.packageName || "-") +
                                    (p.packageCode
                                      ? " (" + p.packageCode + ")"
                                      : ""),
                                  value: p.id,
                                },
                              })
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "pkg-num" }, [
                            _vm._v("数量：1"),
                          ]),
                          _vm._v(" "),
                          _c("el-input", {
                            staticClass: "pkg-alias",
                            attrs: { placeholder: "别名" },
                            model: {
                              value: row.alias,
                              callback: function ($$v) {
                                _vm.$set(row, "alias", $$v)
                              },
                              expression: "row.alias",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-input-number", {
                            staticClass: "pkg-sort",
                            attrs: {
                              min: 0,
                              controls: false,
                              placeholder: "排序",
                            },
                            model: {
                              value: row.sort,
                              callback: function ($$v) {
                                _vm.$set(row, "sort", $$v)
                              },
                              expression: "row.sort",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-button", {
                            staticClass: "pkg-del",
                            attrs: { type: "text", icon: "el-icon-delete" },
                            on: {
                              click: function ($event) {
                                return _vm.removeItem(idx)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      row.couponItems && row.couponItems.length
                        ? _c(
                            "div",
                            { staticClass: "coupon-items-preview" },
                            _vm._l(row.couponItems, function (coupon, ci) {
                              return _c(
                                "div",
                                { key: ci, staticClass: "coupon-item-row" },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      staticClass: "coupon-uploader",
                                      attrs: {
                                        "show-file-list": false,
                                        "http-request": function (opts) {
                                          return _vm.handleCouponImgUpload(
                                            opts,
                                            row,
                                            ci
                                          )
                                        },
                                        accept: "image/*",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "coupon-img-wrap" },
                                        [
                                          coupon.couponImgUrl
                                            ? _c("el-image", {
                                                staticClass: "coupon-img",
                                                attrs: {
                                                  src:
                                                    _vm.resPath +
                                                    coupon.couponImgUrl,
                                                  fit: "cover",
                                                },
                                              })
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "coupon-img-placeholder",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-picture-outline",
                                                  }),
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "coupon-img-mask" },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-upload2",
                                              }),
                                              _vm._v(" 重传"),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "coupon-alias-text" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(coupon.couponAlias || "-") +
                                          "\n                "
                                      ),
                                      coupon.crmCouponId
                                        ? _c(
                                            "span",
                                            { staticClass: "coupon-tpl-id" },
                                            [
                                              _vm._v(
                                                "ID:" +
                                                  _vm._s(coupon.crmCouponId)
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "coupon-num-text" },
                                    [
                                      _vm._v(
                                        "×" + _vm._s(coupon.sendNum || 1) + "张"
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  coupon.oldPrice != null
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "coupon-num-text",
                                          staticStyle: { "margin-left": "8px" },
                                        },
                                        [
                                          _vm._v(
                                            "原价/张：" +
                                              _vm._s(coupon.oldPrice) +
                                              " 元"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                    ])
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        plain: "",
                        size: "mini",
                        icon: "el-icon-plus",
                      },
                      on: { click: _vm.addItem },
                    },
                    [_vm._v("添加券包")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "pkg-tip" }, [
                    _vm._v(_vm._s(_vm.pkgSelectTip)),
                  ]),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "排序" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0 },
                    model: {
                      value: _vm.editForm.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "sort", $$v)
                      },
                      expression: "editForm.sort",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否启用" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.editForm.isEnable,
                        callback: function ($$v) {
                          _vm.$set(_vm.editForm, "isEnable", $$v)
                        },
                        expression: "editForm.isEnable",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.saving },
                  on: { click: _vm.submitEdit },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "领取数据",
            "custom-class": "join-data-dialog",
            visible: _vm.joinVisible,
            width: "900px",
            top: "8vh",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.joinVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "join-dialog-body" },
            [
              _c(
                "el-form",
                {
                  staticClass: "join-search",
                  attrs: { inline: true, model: _vm.joinQuery, size: "small" },
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        staticStyle: { width: "180px" },
                        attrs: {
                          "prefix-icon": "el-icon-search",
                          placeholder: "手机号",
                          clearable: "",
                        },
                        model: {
                          value: _vm.joinQuery.mobile,
                          callback: function ($$v) {
                            _vm.$set(_vm.joinQuery, "mobile", $$v)
                          },
                          expression: "joinQuery.mobile",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "140px" },
                          attrs: { placeholder: "请选择等级", clearable: "" },
                          model: {
                            value: _vm.joinQuery.userRank,
                            callback: function ($$v) {
                              _vm.$set(_vm.joinQuery, "userRank", $$v)
                            },
                            expression: "joinQuery.userRank",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "普卡", value: 10 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "银卡", value: 20 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "金卡", value: 30 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "黑金卡", value: 40 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "钻石卡", value: 50 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "140px" },
                          attrs: { placeholder: "请选择状态", clearable: "" },
                          model: {
                            value: _vm.joinQuery.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.joinQuery, "status", $$v)
                            },
                            expression: "joinQuery.status",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "领取中", value: 0 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "领取成功", value: 1 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "领取失败", value: 2 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleJoinSearch },
                        },
                        [_vm._v("搜索")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.joinLoading,
                      expression: "joinLoading",
                    },
                  ],
                  staticClass: "join-table",
                  attrs: {
                    data: _vm.joinList,
                    border: "",
                    stripe: "",
                    height: "420",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "领取用户", "min-width": "420" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "div",
                              { staticClass: "join-user-cell" },
                              [
                                _c("div", { staticClass: "join-user-text" }, [
                                  _vm._v(_vm._s(_vm.formatJoinUser(row))),
                                ]),
                                _vm._v(" "),
                                row.userpic
                                  ? _c("el-avatar", {
                                      staticClass: "join-user-avatar",
                                      attrs: {
                                        size: 40,
                                        src: _vm.avatarUrl(row.userpic),
                                      },
                                    })
                                  : _c("el-avatar", {
                                      staticClass: "join-user-avatar",
                                      attrs: {
                                        size: 40,
                                        icon: "el-icon-user-solid",
                                      },
                                    }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "领取时间", width: "170", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.formatJoinTime(row.createDate)) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "领取状态", width: "110", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("span", { class: _vm.statusClass(row.status) }, [
                              _vm._v(
                                _vm._s(
                                  row.statusText || _vm.statusText(row.status)
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "join-dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, prev, pager, next",
                  "current-page": _vm.joinQuery.page,
                  "page-size": _vm.joinQuery.limit,
                  total: _vm.joinTotal,
                },
                on: {
                  "current-change": function (p) {
                    _vm.joinQuery.page = p
                    _vm.loadJoin()
                  },
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }